import React from 'react';
import { OverlayView } from '@react-google-maps/api';
import './CustomMarkerOverlay.css';

export const CustomMarkerOverlay = ({ position, message, name, image, onClose, children }) => {
  
  const handleInteraction = (e) => {
    e.stopPropagation(); // Ferma la propagazione dell'evento al DOM
    e.preventDefault();  // Previene il comportamento di default dell'evento
    onClose(); // Chiama la funzione onClose
  };


  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div className="custom-info-wrapper" onClick={(e) => e.stopPropagation()} onTouchEnd={(e) => e.stopPropagation()}>
        <div className="custom-info-bubble">
          <button
            className="close-btn"
            onClick={handleInteraction}
            onTouchEnd={handleInteraction}
          >
            ×
          </button>

          <div className="bubble-content">
            {children ? (
              children
            ) : (
              <>
                <div className="quote-text-scrollable">
                  <p className="quote-text">{message}</p>
                </div>
                {name && <p className="quote-author">{name.toUpperCase()}</p>}
                {image && (
                  <div className="quote-image-container">
                    <img src={image} alt="immagine utente" className="quote-image" />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </OverlayView>
  );
};